/**
 * Longitudes alineadas con reglas / maxLength en Form01 y tabla de Form02 (Colombia Salud).
 */
const L = {
  FIRST_NAME: 20,
  SECOND_FIRST_NAME: 20,
  LAST_NAME: 20,
  EMAIL: 150,
  IDENTIFICATION: 15,
  OCUPACITY: 30,
  ADDRESS: 60,
  CITY: 30,
  APART: 30,
  PHONE: 10,
  PHONE_OFFICE: 20,
  GROUP_NUMBER: 30,
  BENEF_NAME: 25,
  BENEF_LAST_NAME: 25,
  BENEF_DOCUMENT: 15,
  EPS: 40,
};

/** Debe coincidir con PREGUNTAS_CUESTIONARIO_MEDICO en data/colombia/salud/Selects.js */
const CANTIDAD_PREGUNTAS_CUESTIONARIO = 24;

/**
 * Inicializa respuestas del cuestionario médico (Form03) para una persona con datos.
 * Por defecto todo "No" para poder avanzar y saltar Form04 (detalle padecimientos).
 */
function initCuestionarioPersona(persona) {
  persona.respuestas = Array(CANTIDAD_PREGUNTAS_CUESTIONARIO).fill("N");
  if (persona.sex === "F") {
    persona.fechaPregunta22 = "";
    persona.detallePregunta24 = {
      nEmbarazos: "",
      nPartos: "",
      nAbortos: "",
      nCesareas: "",
    };
  }
}

/**
 * Rellena el formulario Colombia Salud con valores de prueba al máximo de longitud permitido
 * en validaciones de texto, dos personas en la grilla (peso, estatura, EPS), cuestionario en "No"
 * para no bloquear el flujo, y continuidad en "No".
 * @param {Object} form — objeto del wizard (se muta)
 */
export function fillColombiaSaludDemoMax(form) {
  const max = (n, ch) => String(ch).repeat(n).slice(0, n);

  form.firstName = max(L.FIRST_NAME, "N");
  form.secondFirstName = max(L.SECOND_FIRST_NAME, "S");
  form.lastName = max(L.LAST_NAME, "L");

  form.identificationType = "CC";
  form.identification = max(L.IDENTIFICATION, "1");
  form.ocupacity = max(L.OCUPACITY, "O");
  form.adress = max(L.ADDRESS, "D");
  form.city = max(L.CITY, "C");
  form.apart = max(L.APART, "A");

  form.phone = max(L.PHONE, "3");
  form.phoneOffice = max(L.PHONE_OFFICE, "4");
  form.phoneMobile = max(L.PHONE, "5");

  if (form.groupNumber === undefined || form.groupNumber === "") {
    form.groupNumber = max(L.GROUP_NUMBER, "G");
  }

  if (form.procedimiento === "INCLUSION") {
    form.birthDay = "1990-05-15";
    form.stature = "1.75";
    form.weight = "75";
  }

  form.illnessDeclaration = "N";
  form.incapacityDeclaration = "N";
  //form.continuidadPoliza = "N";
  //form.declarationsAccepted = true;
  //form.titularEsAsegurado = "N";

  const filaVacia = () => ({
    name: "",
    lastName: "",
    secondLastName: "",
    documentType: "",
    document: "",
    birthDay: "",
    relation: "",
    percentage: "",
    weight: "",
    stature: "",
    sex: "",
    eps: "",
  });

  form.beneficiarios = [];
  form.dependientes = [];

  const relacionesSalud = ["AP", "CO", "HI", "PR", "HE", "SO"];

  [0, 1].forEach((i) => {
    const b = filaVacia();
    form.dependientes.push(b);
    const letra = String.fromCharCode(65 + (i % 26));
    b.name = max(L.BENEF_NAME, letra);
    b.lastName = max(L.BENEF_LAST_NAME, String.fromCharCode(97 + (i % 26)));
    b.secondLastName = max(L.BENEF_LAST_NAME, "Z");
    b.documentType = "CC";
    b.document = String(i + 1).padStart(L.BENEF_DOCUMENT, "0");
    b.birthDay = "2000-06-15";
    b.relation = relacionesSalud[i % relacionesSalud.length];
    b.sex = i % 2 === 0 ? "M" : "F";
    b.weight = i === 0 ? "70.5" : "55";
    b.stature = i === 0 ? "1.72" : "1.60";
    b.eps = max(L.EPS, "E").slice(0, L.EPS);
    initCuestionarioPersona(b);
  });

  form.padecimientos = [];
}
